
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const TeamSection = () => {
  return (
    <section className="px-5 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-start gap-8 md:grid-cols-[minmax(0,0.7fr)_minmax(0,1.3fr)] md:gap-16 lg:gap-20">
          <div>
            <h2 className="text-3xl font-medium md:text-4xl">Who We Are</h2>
            <p className="mt-3 text-sm text-muted-foreground">Our Team</p>
          </div>
          <div className="max-w-2xl">
            <p className="mb-5 text-lg leading-8">
            PaperVerse is built by a dedicated team of former academic researchers, software engineers, and AI specialists who understand the challenges of the research ecosystem from multiple perspectives.
            </p>
            <p className="text-lg leading-8">
            Our combined experience in academia and technology enables us to create tools that genuinely serve the needs of the research community, balancing innovation with the established practices that maintain scientific integrity.
            </p>
          </div>
        </div>

        <div className="mt-16 border-t border-border pt-12 md:mt-24 md:flex md:items-end md:justify-between md:gap-12 md:pt-14">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-medium md:text-4xl">Bring the paper you are working on</h2>
            <p className="mt-5 text-lg leading-8 text-muted-foreground">
              Start with a section that needs writing or a draft that needs a critical read. Your work stays private unless you decide otherwise.
            </p>
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row md:mt-0 md:flex-shrink-0">
            <Button asChild size="lg">
              <Link to="/write">Start writing <ArrowRight aria-hidden="true" /></Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/upload">Review my paper</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
